<template>
    <div class="row mx-0 top-container">
        <div class="col-md-12 main-content">
            <!-- Title -->
            <div class="row title-row">
                <div class="col-lg-4 col-12 credit">
                    Payment Terms: 
                    <span v-if="counterOffer && counterOffer.credit.credit">
                        {{counterOffer.credit.credit.days | creditdaysformat}}
                    </span>
                    <span v-else>
                        N/A
                    </span>
                </div>
                <div class="col-lg-4 col-6 user text-center">
                    My Negotiation:
                </div>
                <div class="col-lg-4 col-6 counterpart text-center">
                    Seller's Counter
                </div>
            </div>

            <!-- Price -->
            <div class="row info-row">
                <div 
                    class="col-lg-4 col-12 label" >
                    Price (ppl)
                </div>
                <div class="col-lg-4 col-6 price-box user px-1 text-center">
                    <div v-if="reviseNegotiationModeActive">
                        <cleave class="form-control input-price" v-model="negotiationRevision.price" placeholder=""
                            :options="numeralPositive" @blur.native="setPriceFormat(negotiationRevision.price, 'PRICE')"
                            @click.native="clearErrorMessages()"></cleave>
                        <span v-if="errorShown == 'PRICE'" class="text-danger">{{errorMessagePrice}}</span>
                    </div>
                    <div v-else>
                        <span class="details-price"
                            :class="{'text-danger mb-3': originalNegotiationPrice !== counterOffer.price}">
                            <!-- Check whether calculated live price exceeds the negotiation's max price -->
                            {{ originalNegotiationPrice | priceformat }}
                        </span>
                    </div>
                </div>
                <div class="col-lg-4 col-6 price-box counterpart px-1 text-center flex-column">
                    <span class="details-price" style="margin-bottom: -10px;"
                        :class="{'text-danger': originalNegotiationPrice !== counterOffer.price}">
                        {{counterOffer.price | priceformat}}
                    </span>
                    <div class="price-delta"
                        :class="(originalNegotiationPrice - counterOffer.price) > 0 ? 'lower' : ((originalNegotiationPrice - counterOffer.price) < 0 ? 'higher' : null)">
                        {{ counterOffer.price - originalNegotiationPrice | pricedeltaformat}}
                    </div>
                </div>
            </div>

            <!-- Max Price -->
            <div v-if="(!reviseNegotiationModeActive && negotiationSelected.type_id == 'TRACKING') ||
                (reviseNegotiationModeActive && negotiationRevision.type =='TRACKING')" 
                class="row info-row">
                <div 
                    class="col-lg-4 col-12 label" >
                    Max Price (ppl)
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="!reviseNegotiationModeActive">
                        {{negotiationSelected.maxPrice | priceformat}}
                    </span>
                    <div v-else>
                        <cleave v-model="negotiationRevision.maxPrice" @blur.native="setPriceFormat(negotiationRevision.maxPrice, 'MAX-PRICE')"
                            :options="numeralPositive" @click.native="clearErrorMessages()"></cleave>
                        <span v-if="errorShown == 'MAX-PRICE'" class="text-danger">{{errorMessageMaxPrice}}</span>
                    </div>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                </div>
            </div>

            <!-- Time Remaining -->
            <div v-if="!finalStatusDisplayed" class="row info-row">
                <div class="col-lg-4 col-12 label" >
                    Time Remaining
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <div v-if="!reviseNegotiationModeActive">
                        <div v-if="new Date(negotiationSelected.expires) - new Date() > 0 && negotiationSelected.status_id == 'ACTIVE'">
                            <span class="negotiation-countdown text-center timer-displaying">
                                <span class="text-display">{{(new Date(negotiationSelected.expires) - new Date())/1000 | countdownshortformat}}</span>
                                <radial-progress-bar class="countdown-progress" :diameter="35" 
                                    :totalSteps="totalCountdownTime" 
                                    :completedSteps="timeRemaining" />
                            </span>
                        </div>
                        <span v-else class="negotiation-countdown counter text-center">
                            <span v-if="negotiationSelected.status_id == 'COMPLETED'" class="text-olf-green">
                                <span v-if="!(negotiationSelected.counterOffers && negotiationSelected.counterOffers.find(counter => counter.status_id == 'COMPLETED'))">
                                    Accepted
                                </span>
                            </span>
                            <span v-else class="text-danger">
                                <span v-if="!(new Date(negotiationSelected.expires) - new Date() > 0)">Negotiation has expired</span>
                                <span v-else-if="negotiationSelected.status_id == 'WITHDRAWN'">Negotiation has been withdrawn</span>
                                <span v-else>Loading</span>
                            </span>
                        </span>
                    </div>
                    <span v-else>
                        <div class="select-wrapper">
                            <select v-model="negotiationRevision.period">
                                <option :value="negotiationPeriod" v-for="(negotiationPeriod, index) in negotiationPeriodList" :key="index"
                                    :disabled="negotiationPeriod == -1">
                                    <span v-if="index == 0">Select Time Valid</span>
                                    <span v-else>{{negotiationPeriod | negotiationperiodformat}}</span>
                                </option>
                            </select>
                        </div>
                        <span v-if="errorShown == 'PERIOD'" class="text-danger">{{errorMessagePeriod}}</span>
                    </span>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="offersTimeRemaining[counterOffer._id] > 0 && negotiationSelected.status_id == 'ACTIVE'" 
                        class="negotiation-countdown timer-displaying">
                        <span class="text-display">{{offersTimeRemaining[counterOffer._id] | countdownshortformat}}</span>
                        <radial-progress-bar class="countdown-progress" :diameter="35" 
                            :totalSteps="parseInt((new Date(counterOffer.expires) - new Date(counterOffer.created))/1000)" 
                            :completedSteps="offersTimeRemaining[counterOffer._id]" />
                    </span>
                    <span v-else class="negotiation-countdown">
                        <span v-if="counterOffer.status_id == 'COMPLETED'" class="text-olf-green">Accepted</span>
                        <span v-else>
                            <span v-if="offersTimeRemaining[counterOffer._id] == undefined && negotiationSelected.status_id == 'ACTIVE' 
                                && new Date(counterOffer.expires) > new Date()">Loading</span>
                            <span v-else-if="!(negotiationSelected.accepting_user && negotiationSelected.accepting_user.account.id == counterOffer.user.account.id)" class="text-danger">
                                Expired
                            </span>
                        </span>
                    </span>
                </div>
            </div>

            <!-- Volume -->
            <div class="row info-row">
                <div class="col-lg-4 col-12 label" >
                    Volume/L
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="!reviseNegotiationModeActive" :class="{'text-danger':counterOffer.quantity !== negotiationSelected.quantity}">
                        {{negotiationSelected.quantity | volumeformat}}
                    </span>
                    <div v-else>
                        <cleave class="form-control" v-model="negotiationRevision.quantity" 
                            :options="numeralPositive" @click.native="clearErrorMessages()"></cleave>
                        <span v-if="errorShown == 'QUANTITY'" class="text-danger error-message-popup">{{errorMessageQuantity}}</span>
                    </div>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span :class="{'text-danger':counterOffer.quantity !== negotiationSelected.quantity}">
                        {{counterOffer.quantity | volumeformat}}
                    </span>
                </div>
            </div>

            <!-- Terminal -->
            <div v-if="negotiationType == 'SPOT'" class="row info-row">
                <div class="col-lg-4 col-12 label" >
                    Terminal
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <div v-if="!reviseNegotiationModeActive">
                        <span v-if="negotiationSelected.terminal" 
                            :class="{'text-danger':counterOffer.terminal_id !== negotiationSelected.terminal_id}">
                            {{negotiationSelected.terminal.name}}
                        </span>
                    </div>
                    <div v-else class="select-wrapper">
                        <select id="select-terminal" v-model="negotiationRevision.terminal"
                            :class="{'text-danger':counterOffer.terminal_id !== negotiationRevision.terminal._id}">
                            <option :value="terminal" v-for="(terminal,index) in terminals" :key="index">
                                {{terminal.name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="counterOffer.terminal" 
                        :class="{'text-danger':negotiationSelected.terminal && counterOffer.terminal_id !== negotiationSelected.terminal_id}">
                        {{counterOffer.terminal.name}}
                    </span>
                </div>
            </div>

            <!-- Measurement -->
            <div class="row info-row">
                <div class="col-lg-4 col-12 label" >
                    Measurement
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="!reviseNegotiationModeActive"  
                        :class="{'text-danger':counterOffer.fuel_measurement_id !== negotiationSelected.fuel_measurement_id}">
                        {{negotiationSelected.fuel_measurement_id | fuelmeasurementtype}}
                    </span>
                    <div v-else class="select-wrapper">
                        <select id="select-measurement" v-model="negotiationRevision.fuel_measurement"
                            :class="{'text-danger':counterOffer.fuel_measurement_id !== negotiationRevision.fuel_measurement}">
                            <option :value="measurementType" v-for="(measurementType,index) in measurements" :key="index">
                                {{measurementType | fuelmeasurementtype}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span :class="{'text-danger':counterOffer.fuel_measurement_id !== negotiationSelected.fuel_measurement_id}">
                        {{counterOffer.fuel_measurement_id | fuelmeasurementtype}}
                    </span>
                </div>
            </div>

            <!-- Lifting Period -->
            <div v-if="negotiationType == 'SPOT'" class="row info-row">
                <div class="col-lg-4 col-12 label" >
                    Lifting Period
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="!reviseNegotiationModeActive"  
                        :class="{'text-danger':counterOffer.collectionTime !== negotiationSelected.collectionTime}">
                        {{negotiationSelected.collectionTime | collectiondaysformat}}
                    </span>
                    <div v-else class="select-wrapper">
                        <select id="select-collection-period" v-model="negotiationRevision.collectionTime"
                            :class="{'text-danger':counterOffer.collectionTime !== negotiationRevision.collectionTime}">
                            <option :value="collectionPeriod" v-for="(collectionPeriod,index) in collectionPeriodList" :key="index">
                                {{collectionPeriod | collectiondaysformat}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span :class="{'text-danger':counterOffer.collectionTime !== negotiationSelected.collectionTime}">
                        {{counterOffer.collectionTime | collectiondaysformat}}
                    </span>
                </div>
            </div>

            <!-- Pricing Method -->
            <div class="row info-row">
                <div class="col-lg-4 col-12 label" >
                    Pricing Method
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="!reviseNegotiationModeActive">
                        {{negotiationSelected.type_id | offertype}}
                    </span>
                    <div v-else class="select-wrapper">
                        <select id="select-negotiation-type" v-model="negotiationRevision.type"
                            :class="{'text-danger':negotiationSelected.type_id !== negotiationRevision.type}">
                            <option :value="negotiationType" v-for="(negotiationType, index) in negotiationTypeList" :key="index">
                                {{negotiationType | offertype}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                </div>
            </div>

            <!-- Final status -->
            <div v-if="finalStatusDisplayed" class="row info-row status">
                <div class="col-lg-4 text-center  col-12">
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="negotiationSelected.status_id == 'COMPLETED' && !(negotiationSelected.counterOffers && negotiationSelected.counterOffers.find(counter => counter.status_id == 'COMPLETED'))" class="positive">
                        <i class="fas fa-check-circle"></i>&nbsp;Accepted
                    </span>
                    <span v-else-if="negotiationSelected.status_id !== 'COMPLETED'" class="text-danger">
                        <span v-if="negotiationSelected.status_id == 'WITHDRAWN'">Withdrawn</span>
                        <span v-else-if="!(new Date(negotiationSelected.expires) - new Date() > 0)">Expired</span>
                        <span v-else>Loading</span>
                    </span>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="counterOffer.status_id == 'COMPLETED'" class="positive">
                        <i class="fas fa-check-circle"></i>&nbsp;Accepted
                    </span>
                    <span v-else>
                        <span v-if="!offersTimeRemaining[counterOffer._id] && negotiationSelected.status_id == 'ACTIVE' 
                            && new Date(counterOffer.expires) > new Date()">Loading</span>
                        <span v-else-if="!(negotiationSelected.accepting_user && negotiationSelected.accepting_user.account.id == counterOffer.user.account.id)" class="text-danger">
                            Expired
                        </span>
                    </span>
                </div>
            </div>

            <!-- Total Cost -->
            <div class="row info-row total">
                <div class="col-lg-4 col-12 label" >
                    Total Cost
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span v-if="!reviseNegotiationModeActive" 
                        :class="{'text-danger': ((counterOffer.price/100 * counterOffer.quantity).toFixed(2) !== (originalNegotiationPrice/100 * negotiationSelected.quantity).toFixed(2))}">
                        £{{originalNegotiationPrice/100 * negotiationSelected.quantity | priceformat}}
                    </span>
                    <span v-else 
                        :class="{'text-danger': ((counterOffer.price/100 * counterOffer.quantity).toFixed(2) !== (negotiationRevision.price/100 * negotiationRevision.quantity).toFixed(2))}">
                        £{{negotiationRevision.price/100 * negotiationRevision.quantity | priceformat}}
                    </span>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <span :class="{'text-danger': ((counterOffer.price/100 * counterOffer.quantity).toFixed(2) !== (originalNegotiationPrice/100 * negotiationSelected.quantity).toFixed(2))}">
                        £{{(counterOffer.price/100 * counterOffer.quantity) | priceformat}}
                    </span>
                </div>
            </div>

            <!-- Actions -->
            <div class="row info-row actions">
                <div class="col-lg-4 text-center  col-12">
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <button class="btn btn-secondary w-75" v-if="!reviseNegotiationModeActive"
                        :disabled="!(new Date(negotiationSelected.expires) - new Date() > 0) || reviseNegotiationModeActive || negotiationSelected.status_id !== 'ACTIVE'" 
                        @click="reviseNegotiation()">Renegotiate</button>
                    <button class="btn btn-primary w-75" v-else @click="updateNegotiation()"
                        :disabled="!(timeRemaining > 0) || !reviseNegotiationModeActive || negotiationSelected.status_id !== 'ACTIVE'">Confirm</button>
                </div>
                <div class="col-lg-4 text-center  col-6 px-1">
                    <button class="btn btn-primary w-75" :disabled="!(offersTimeRemaining[counterOffer._id] > 0) || negotiationSelected.status_id !== 'ACTIVE'"
                        @click="acceptCounter()">Accept</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data(){
        return {
            counterOffer: '',
            reviseNegotiationModeActive: false,
            negotiationRevision: {
                price: 0,
                maxPrice: 0,
                quantity: 0,
                terminal: {
                    _id: '',
                    name: 'None selected'
                },
                fuel_measurement: '',
                collectionTime: 0,
                type: '',
                period: -1
            },
            measurements: ['STANDARD', 'AMBIENT'],
            collectionPeriodList: [0, 1, 2, 3, 7, 30],
            negotiationTypeList: ['FIXED', 'TRACKING'],
            negotiationPeriodList: [-1, 15, 30, 60, 99],
            errorMessagePrice: 'Negotiation price must be greater than 0',
            errorMessageMaxPrice: 'Max Price cannot be less than Your Price',
            errorMessageQuantity: 'Volume must be an integer greater than 0',
            errorMessagePeriod: 'Please select how long your negotiation will be valid for',
            errorShown: '',
            timeRemaining: 0,
            countdownFunction: ''
        }
    },
    computed: {
        ...mapState('negotiation',['negotiationSelected','activeTabIndex','offersTimeRemaining', 'showAcceptCounterOffer']),
        ...mapState('notifications', ['notificationList']),
        ...mapState('inputCheckers',['numeralPositive', 'maxExpiryTime']),
        ...mapState('terminals',['terminals']),
        ...mapState('fuelsType', ['fuels']),
        ...mapGetters('negotiation', ['getFuelPricesChanges', 'getNegotiationListTimer']),
        
        /* IF the current negotiation ID is found in the current notification list, mark as viewed */
        clearCurrentNegotiationNotification: function(){
            this.shouldNotificationBeRemoved()
        },
        populateCounterOfferDetails: function(){
            if (Object.keys(this.negotiationSelected).length > 0 && 
                this.negotiationSelected.counterOffers.length > 0) {
                this.counterOffer = this.negotiationSelected.counterOffers[this.activeTabIndex - 1]
            }
        },
        negotiationType: {
            get: function(){
                if (this.fuels && Object.keys(this.negotiationSelected).length > 0){
                    const fuel = this.fuels.find(fuel => fuel._id == this.negotiationSelected.fuel_id)
                    
                    if (fuel){
                        return fuel.type
                    }
                }
            }
        },
        performCountdown: function(){
            if (Object.keys(this.negotiationSelected).length > 0){
                if (this.countdownFunction){
                    clearInterval(this.countdownFunction)
                }
                this.timeRemaining = (new Date(this.negotiationSelected.expires) - new Date())/1000
                if (this.timeRemaining > 0){
                    this.countdownFunction = setInterval(()=>{
                            this.timeRemaining --
                            if (this.timeRemaining < 1){
                                clearInterval(this.countdownFunction)
                            }
                        }, 1000)
                }
            }
        },
        totalCountdownTime: {
            get: function(){
                if (Object.keys(this.negotiationSelected).length > 0){
                    return (new Date(this.negotiationSelected.expires) - new Date(this.negotiationSelected.created))/1000
                }
            }
        },
        openAcceptCounterOfferModal: function(){
            if (this.showAcceptCounterOffer){
                let element = this.$root.$refs.acceptCounterOffer.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
        },
        disableRevisionIfInactive: function(){
            // Once a counter offer is accepted, revising negotiation mode should be inactive
            if (Object.keys(this.negotiationSelected).length > 0 && this.negotiationSelected.status_id !== 'ACTIVE'){
                this.resetNegotiationRevision()
            }
        },
        finalStatusDisplayed: {
            get: function(){
                if (this.negotiationSelected.status_id !== 'ACTIVE' || 
                    (this.timeRemaining <= 0 && !(this.offersTimeRemaining[this.counterOffer._id] > 0 && this.negotiationSelected.status_id == 'ACTIVE'))){
                    return true
                }
                else {
                    return false
                }
            }
        },
        originalNegotiationPrice: {
            get: function(){
                let price = 0

                if (this.negotiationSelected.status_id == 'COMPLETED')
                    price = this.negotiationSelected.accepted_counter_offer_id ? this.negotiationSelected.priceBeforeOrder : this.negotiationSelected.price
                else
                    price = this.negotiationSelected.type_id == 'FIXED' ? this.negotiationSelected.price : this.negotiationSelected.livePrice

                return price
            }
        }
    },
    watch: {
        populateCounterOfferDetails(){},
        performCountdown(){},
        openAcceptCounterOfferModal(){},
        disableRevisionIfInactive(){},
        clearCurrentNegotiationNotification(){}, // Watcher for clearing current negotiation off notification list
    },
    methods: {
        ...mapActions('negotiation', ['reviseActiveNegotiation', 'updateShowAcceptCounterOffer', 'setAcceptedCounterId']),
        ...mapActions('notifications', ['updateNotification']),
        clearErrorMessages: function(){
            this.errorShown = ''
        },
        shouldNotificationBeRemoved: function(){
            /* Remove red dot notifications for this counter offer */
            let currentRelevantNotification = this.notificationList.find(notification => notification.type_id === 'NEGOTIATION' && notification.group_id === this.negotiationSelected._id && notification.meta && notification.meta.counterOfferId === this.negotiationSelected.counterOffers[this.activeTabIndex - 1]._id && notification.viewed === null)

            if(currentRelevantNotification){
                this.updateNotification(this.negotiationSelected._id);
            }
        },
        acceptCounter: function(){
            /* Check if there are notifications related to this counter offer */
            this.shouldNotificationBeRemoved()

            this.setAcceptedCounterId(this.counterOffer._id)
            this.updateShowAcceptCounterOffer(true)
        },
        reviseNegotiation: function(){
            this.reviseNegotiationModeActive = true
            
            /* Check if there are notifications related to this counter offer */
            this.shouldNotificationBeRemoved()

            this.negotiationRevision.price = (this.negotiationSelected.type_id == 'TRACKING' ?
                Number(this.negotiationSelected.livePrice) : Number(this.negotiationSelected.price)).toFixed(2)
            this.negotiationRevision.maxPrice = Number(this.negotiationSelected.maxPrice).toFixed(2)
            this.negotiationRevision.quantity = Number(this.negotiationSelected.quantity)
            this.negotiationRevision.terminal = Object.assign({}, this.negotiationSelected.terminal)
            this.negotiationRevision.fuel_measurement = this.negotiationSelected.fuel_measurement_id
            this.negotiationRevision.collectionTime = this.negotiationSelected.collectionTime
            this.negotiationRevision.type = this.negotiationSelected.type_id

            if (this.negotiationSelected.negotiation_period_id == -1){
                this.negotiationRevision.period = 99
            }
            else {
                let timeValid = this.negotiationSelected.negotiation_period_id/60
                this.negotiationRevision.period = Number(timeValid)
            }
        },
        updateNegotiation: async function(){
            /* Check if there are notifications related to this counter offer */
            this.shouldNotificationBeRemoved()

            if (this.negotiationRevision.price == 0){ // Check for valid price
                this.errorShown = 'PRICE'
                setTimeout(()=>{
                    this.errorShown = ''
                }, 2000)
            }
            else if (this.negotiationRevision.type == 'TRACKING' && (Number(this.negotiationRevision.maxPrice) < Number(this.negotiationRevision.price))){
                this.errorShown = 'MAX-PRICE'
                setTimeout(()=>{
                    this.errorShown = ''
                }, 2000)
            }
            else if (this.negotiationRevision.quantity == 0 || !Number.isInteger(Number(this.negotiationRevision.quantity))){ // Check for valid volume
                this.errorShown = 'QUANTITY'
                setTimeout(()=>{
                    this.errorShown = ''
                }, 2000)
            }
            else if (this.negotiationRevision.period == -1 || !this.negotiationRevision.period){ // Check if a valid time has been selected
                this.errorShown = 'PERIOD'
                setTimeout(()=>{
                    this.errorShown = ''
                }, 2000)
            }
            else {
                this.confirmNegotiationRevision()
            }
        },
        resetNegotiationRevision: function(){
            this.reviseNegotiationModeActive = false
            this.negotiationRevision.price = 0
            this.negotiationRevision.quantity = 0
            this.negotiationRevision.terminal = {
                _id: '',
                name: 'None selected'
            }
            this.negotiationRevision.fuel_measurement = ''
            this.negotiationRevision.collectionTime = 0
            this.negotiationRevision.type = ''
            this.negotiationRevision.period = 0
        },
        setPriceFormat: function(price, type){
            if (type == 'PRICE'){
                this.negotiationRevision.price = Number(price).toFixed(2)
            }
            else if (type == 'MAX-PRICE'){
                this.negotiationRevision.maxPrice = Number(price).toFixed(2)
            }
        },
        confirmNegotiationRevision: function(){
            const moment = require('moment')

            let revision = {
                fuel_id: this.negotiationSelected.fuel_id,
                quantity: Number(this.negotiationRevision.quantity),
                price: this.negotiationRevision.type == 'FIXED' ? 
                    Number(this.negotiationRevision.price) : 
                        (Number(this.negotiationRevision.price) - Number(this.getFuelPricesChanges.find(fuel => 
                                fuel.fuel_id == this.negotiationSelected.fuel_id).basePrice)),
                maxPrice: this.negotiationRevision.type == 'FIXED' ? Number(this.negotiationRevision.price) : Number(this.negotiationRevision.maxPrice),
                terminal_id: this.negotiationType == 'SPOT' ? this.negotiationRevision.terminal._id : null,
                fuel_measurement_id: this.negotiationRevision.fuel_measurement,
                collectionTime: this.negotiationRevision.collectionTime,
                type_id: this.negotiationRevision.type,
                reference: this.negotiationSelected.reference,
                periodId: this.negotiationRevision.period == 99 || (this.negotiationRevision.period !== 99 &&
                    new Date(moment().add(this.negotiationRevision.period, 'minutes').toDate()) > new Date(this.maxExpiryTime))?
                    'EOD' : this.negotiationRevision.period + 'M'
            }

            const payload = {
                revisedNegotiation: revision,
                negotiation_id: this.negotiationSelected._id
            }
            this.reviseActiveNegotiation(payload)
            this.resetNegotiationRevision()
        }
    },
    beforeDestroy(){
        clearInterval(this.countdownFunction)
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/_negotiations.scss";
</style>
